import { render, staticRenderFns } from "./EditUserForm.vue?vue&type=template&id=352d83e0&scoped=true&"
import script from "./EditUserForm.vue?vue&type=script&lang=js&"
export * from "./EditUserForm.vue?vue&type=script&lang=js&"
import style0 from "./EditUserForm.vue?vue&type=style&index=0&id=352d83e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d83e0",
  null
  
)

export default component.exports